import { createApiRef, IdentityApi } from '@backstage/core-plugin-api';
import { RestClientApi } from '@runway/devkit-common';

export interface ADOServiceApi {
  getProjects(): Promise<any>;
  getRepositories(projectId: string): Promise<any>;
  getProjectAdmins(projectId: string): Promise<any>;
}

export const ADOServiceApiRef = createApiRef<ADOServiceApi>({
  id: 'packages.devkit.src.service.ado.service',
});

export class ADOService implements ADOServiceApi {
  constructor(
    private backendUrl: string,
    private restClient: RestClientApi,
    private identityApi: IdentityApi,
  ) {}

  async getProjects() {
    const { token } = await this.identityApi.getCredentials();
    return (
      await this.restClient.get(`${this.backendUrl}/api/ado-access`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
    ).data.value;
  }

  async getRepositories(projectId: string) {
    const { token } = await this.identityApi.getCredentials();
    return (
      await this.restClient.get(`${this.backendUrl}/api/ado-access/${projectId}/repositories`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
    ).data.value;
  }

  async getProjectAdmins(projectId: string) {
    const { token } = await this.identityApi.getCredentials();
    return this.restClient.get(`${this.backendUrl}/api/ado-access/${projectId}/projectAdmins`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
  }
}

export default ADOService;
